import React from 'react';
import './button.css';
import '../colors/index.css';

class Button extends React.Component {
    render(){
    	const {className, type, ...other} = this.props;

		if(this.props.className){
			return (
                <button type={type ? type : 'button'} className={`btn ${className}`} {...other} disabled={this.props.disabled} onClick={this.props.onClick}>{this.props.children}</button>
			)
		} else {
			return (
                <button type={type ? type : 'button'} className={`btn`} {...other} disabled={this.props.disabled} onClick={this.props.onClick}>{this.props.children}</button>
			)
		}
    }
}

export default Button;